export const aracDegerKaybiPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Araç Değer Kaybı</h1>
        <p class="page-subtitle">Kaza sonrası aracınızın değer kaybını kusurlu tarafın trafik sigortasından talep edebilirsiniz. Süreç hakkında bilgi alın ve profesyonel destek ile hakkınızı arayın.</p>
      </div>

      <div class="info-cards">
        <div class="info-card">
          <h3>Araç Değer Kaybı Nedir?</h3>
          <p>Kaza geçiren araç ne kadar iyi onarılırsa onarılsın "hasar kaydı" oluşur ve araç alıcı gözünde değer kaybeder. İşte bu maddi düşüşe <strong>değer kaybı</strong> denir.</p>
        </div>

        <div class="info-card">
          <h3>Kimler Alabilir?</h3>
          <ul>
            <li>Kazada %100 kusurlu <strong>değilseniz</strong></li>
            <li>Araçta hasar oluştuysa</li>
            <li>Hasar gören parçalar boya/değişim gördüyse</li>
          </ul>
        </div>

        <div class="info-card">
          <h3>Kimler Alamaz?</h3>
          <ul>
            <li>%100 kusurlu olanlar</li>
            <li>Çok eski / yüksek kilometreli araçlar (genelde 165.000 km üstü)</li>
            <li>Daha önce aynı yerden ağır hasarlı araçlar</li>
          </ul>
        </div>
      </div>

      <div class="service-detail-section">
        <h2>Gerekli Belgeler</h2>
        <div class="checklist">
          <div class="checklist-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M9 11l3 3L22 4"></path></svg>
            <span>Kaza tespit tutanağı</span>
          </div>
          <div class="checklist-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M9 11l3 3L22 4"></path></svg>
            <span>Ruhsat fotokopisi</span>
          </div>
          <div class="checklist-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M9 11l3 3L22 4"></path></svg>
            <span>Hasar fotoğrafları</span>
          </div>
          <div class="checklist-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M9 11l3 3L22 4"></path></svg>
            <span>Ekspertiz raporu</span>
          </div>
          <div class="checklist-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M9 11l3 3L22 4"></path></svg>
            <span>IBAN bilgisi</span>
          </div>
        </div>
      </div>

      <div class="service-detail-section">
        <h2>Yaklaşık Değer Kaybı Tutarları</h2>
        <div class="price-table">
          <div class="price-row">
            <span class="price-label">Küçük hasar</span>
            <span class="price-value">5.000 – 15.000 TL</span>
          </div>
          <div class="price-row">
            <span class="price-label">Orta hasar</span>
            <span class="price-value">15.000 – 40.000 TL</span>
          </div>
          <div class="price-row">
            <span class="price-label">Büyük hasar</span>
            <span class="price-value">40.000 TL ve üzeri</span>
          </div>
        </div>
        <p class="price-note">* Tutarlar aracın yaşı, kilometresi, hasarın büyüklüğü ve değişen/boyanan parça sayısına göre değişir.</p>
      </div>

      <div class="service-detail-section">
        <h2>Başvuru Süreci</h2>
        <div class="steps">
          <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
              <h4>Başvuru</h4>
              <p>Kusurlu aracın trafik sigortasına başvurulur</p>
            </div>
          </div>
          <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
              <h4>Bekleme</h4>
              <p>15 gün içinde cevap gelmezse Sigorta Tahkim Komisyonu'na başvurulur</p>
            </div>
          </div>
          <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
              <h4>Ödeme</h4>
              <p>Ortalama 2–8 hafta içinde ödeme yapılır</p>
            </div>
          </div>
        </div>
        <p class="price-note">Başvuru süresi: Kaza tarihinden itibaren <strong>2 yıl</strong></p>
      </div>

      <div class="service-cta highlight-cta">
        <h2>Değer Kaybı Danışmanlığı</h2>
        <p>Eksik başvuru yaparsanız düşük ödeme alabilirsiniz. Profesyonel destek ile daha yüksek tutar alabilirsiniz. Bize araç modelinizi, hasar durumunuzu ve km bilginizi iletin — yaklaşık değer kaybınızı hesaplayalım.</p>
        <div class="cta-buttons">
          <a href="tel:+905368949636" class="btn-primary">Hemen Arayın</a>
          <a href="https://wa.me/+905368949636" class="btn-outline" target="_blank" rel="noopener">WhatsApp ile Danışın</a>
        </div>
      </div>
    </div>
  </section>
`;
